import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const LatviaLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'LV',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Latvia',
  SHORT_NAME: 'LV',

  DISPLAY_NAME: 'Latvia (English)',
  DISPLAY_COUNTRY: 'Latvia (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 56.8553669,
    INITIAL_LONGITUDE: 21.9057323,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Ādaži',
    '2': 'Aizkraukle',
    '3': 'Alūksne',
    '4': 'Augšdaugava',
    '5': 'Balvi',
    '6': 'Bauska',
    '7': 'Cēsis',
    '8': 'Dobele',
    '9': 'Gulbene',
    '10': 'Jelgava',
    '11': 'Jēkabpils',
    '12': 'Ķekava',
    '13': 'Krāslava',
    '14': 'Kuldīga',
    '15': 'Limbaži',
    '16': 'Līvāni',
    '17': 'Ludza',
    '18': 'Madona',
    '25': 'Mārupe',
    '26': 'Ogre',
    '27': 'Olaine',
    '28': 'Preiļi',
    '29': 'Rēzekne',
    '30': 'Ropaži',
    '31': 'Salaspils',
    '32': 'Saldus',
    '33': 'Saulkrasti',
    '34': 'Sigulda',
    '35': 'Smiltene',
    '36': 'South Kurzeme',
    '37': 'Talsi',
    '38': 'Tukums',
    '39': 'Valka',
    '40': 'Valmiera',
    '41': 'Varakļāni',
    '42': 'Ventspils',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-lv/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-lv/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{4}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default LatviaLocale
